import http from "@/utils/request";

const douYinApi = {
  pageQuery: data =>
    http.sendRequest({
      METHOD_NAME: "douYinWarehouseFeeOrder.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {}
    })
};

export default douYinApi;
